import {ChangeDetectorRef, Component, Input, OnDestroy, OnInit} from "@angular/core";
import {FormGroup} from "@angular/forms";
import {ErrorHandlerService} from "../../../error-handler.service";
import {CustomerInstanceVenueModel} from "../customer-instance-venue.model";
import {VenueCompany} from "./venue-company.data";
import {VenueCompanyService} from "./venue-company.service";
import {Subscription} from "rxjs";

@Component({
    selector: "fhm-venue-company",
    styles: [":host {display: flex; width: 100%;}"],
    templateUrl: "./venue-company.component.html",
    styleUrls: ["./venue-company.component.scss"],
    providers: [VenueCompanyService],
    standalone: false
})
export class VenueCompanyComponent implements OnInit, OnDestroy {

    data: VenueCompany;

    editing: boolean;

    subscription: Subscription = new Subscription();

    @Input() formGroupCompany: FormGroup;

    constructor(private errorHandler: ErrorHandlerService,
                public model: CustomerInstanceVenueModel,
                private changeDetectorRef: ChangeDetectorRef) {
    }

    ngOnInit(): void {
        this.subscription.add(this.model.data$.subscribe(() => {
            this.changeDetectorRef.detectChanges();
            this.data = this.model.draft ? this.model.data.company : Object.assign({}, this.model.data.company);
            this.editing = this.model.draft || this.newEntity;
        }));
    }

    ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }

    async save(): Promise<void> {
        if (this.formGroupCompany.valid) {
            try {
                await this.model.saveCompany(this.data);
                this.editing = false;
            } catch (e) {
                this.errorHandler.handleErrorResponse(e);
            }
        }
    }

    edit(): void {
        this.editing = true;
    }

    cancelEdit(): void {
        this.data = Object.assign({}, this.model.data.company);
        this.editing = false;
    }

    get newEntity(): boolean {
        return !this.data.id;
    }
}
